/**
 * Sentry Integration
 * Handles error tracking and performance monitoring.
 */

import * as Sentry from '@sentry/react';

export const initSentry = () => {
    const dsn = import.meta.env.VITE_SENTRY_DSN;
    const environment = import.meta.env.VITE_APP_ENV || 'development';

    if (!dsn) {
        if (environment === 'production') {
            console.warn('Sentry DSN not found in production environment.');
        }
        return;
    }

    Sentry.init({
        dsn,
        environment,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
        // Session Replay
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,

        // Before send hook for filtering sensitive data
        beforeSend(event) {
            // Drop events that might contain sensitive info if needed
            return event;
        },
    });
};

export const captureException = (error: unknown, context?: Sentry.CaptureContext) => {
    Sentry.captureException(error, context);
};

export const captureMessage = (message: string, context?: Sentry.CaptureContext | Sentry.SeverityLevel) => {
    Sentry.captureMessage(message, context);
};
